import { Controller } from "@hotwired/stimulus"

export default class LoansSearch extends Controller {
  static targets = ["form", "input", "results"]
  connect () {
    console.log("LoansSearchController connected")
  }
  reset(): void {
    this.inputTarget.value = ""
  }

  basicSubmit(): void {
    this.formTarget.requestSubmit()
  }

  submit = this.debounce(this.basicSubmit.bind(this))

  debounce(functionToDebounce: Function, wait = 300) {
    let timeoutId = null

    return (...args: any[]) => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => {
        timeoutId = null
        functionToDebounce(...args)
      }, wait)
    }
  }

  calculateFee(): void {

  }
}
